import { render, staticRenderFns } from "./declareList.vue?vue&type=template&id=2067bc20&scoped=true"
import script from "./declareList.vue?vue&type=script&lang=js"
export * from "./declareList.vue?vue&type=script&lang=js"
import style0 from "./declareList.vue?vue&type=style&index=0&id=2067bc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067bc20",
  null
  
)

export default component.exports